import { render, staticRenderFns } from "./cardInformation.vue?vue&type=template&id=2084412c&scoped=true&"
import script from "./cardInformation.vue?vue&type=script&lang=js&"
export * from "./cardInformation.vue?vue&type=script&lang=js&"
import style0 from "./cardInformation.vue?vue&type=style&index=0&id=2084412c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2084412c",
  null
  
)

export default component.exports